import React, { useState, useEffect } from 'react'
import NavBar from '../component/NavBar'

// Local COVID-19 images from public folder
const covidImages = [
  { id: 1, src: '/covid1.jpg', alt: 'COVID-19 Relief Activity 1', category: 'Relief' },
  { id: 2, src: '/covid2.jpg', alt: 'COVID-19 Relief Activity 2', category: 'Relief' },
  { id: 3, src: '/covid3.jpg', alt: 'COVID-19 Relief Activity 3', category: 'Healthcare' },
  { id: 4, src: '/covid4.jpg', alt: 'COVID-19 Relief Activity 4', category: 'Healthcare' },
  { id: 5, src: '/covid5.jpg', alt: 'COVID-19 Relief Activity 5', category: 'Prevention' },
  { id: 6, src: '/covid6.jpg', alt: 'COVID-19 Relief Activity 6', category: 'Prevention' },
  { id: 7, src: '/covid7.jpg', alt: 'COVID-19 Relief Activity 7', category: 'Awareness' },
  { id: 8, src: '/covid8.jpg', alt: 'COVID-19 Relief Activity 8', category: 'Awareness' },
  { id: 9, src: '/covid9.jpg', alt: 'COVID-19 Relief Activity 9', category: 'Care' },
  { id: 10, src: '/covid10.jpg', alt: 'COVID-19 Relief Activity 10', category: 'Care' },
  { id: 11, src: '/covid11.jpg', alt: 'COVID-19 Relief Activity 11', category: 'Relief' },
  { id: 12, src: '/covid12.jpg', alt: 'COVID-19 Relief Activity 12', category: 'Relief' },
  { id: 13, src: '/covid13.jpg', alt: 'COVID-19 Relief Activity 13', category: 'Healthcare' },
  { id: 14, src: '/covid14.jpg', alt: 'COVID-19 Relief Activity 14', category: 'Healthcare' },
  { id: 15, src: '/covid15.jpg', alt: 'COVID-19 Relief Activity 15', category: 'Prevention' },
  { id: 16, src: '/covid16.jpg', alt: 'COVID-19 Relief Activity 16', category: 'Prevention' },
  // { id: 17, src: '/covid17.jpg', alt: 'COVID-19 Relief Activity 17', category: 'Awareness' },
  // { id: 18, src: '/covid18.jpg', alt: 'COVID-19 Relief Activity 18', category: 'Awareness' },
  // { id: 19, src: '/covid19.jpg', alt: 'COVID-19 Relief Activity 19', category: 'Care' },
  // { id: 20, src: '/covid20.jpg', alt: 'COVID-19 Relief Activity 20', category: 'Care' },
]

const categories = ['All', 'Relief', 'Healthcare', 'Prevention', 'Awareness', 'Care']

function Covid19() {
  const [selectedImage, setSelectedImage] = useState(null)
  const [activeCategory, setActiveCategory] = useState('All')
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)
  const [brokenImages, setBrokenImages] = useState(new Set())

  // Filter images based on category
  const filteredImages = activeCategory === 'All' 
    ? covidImages 
    : covidImages.filter(img => img.category === activeCategory)

  // Handle image click
  const handleImageClick = (image) => {
    setSelectedImage(image)
    setIsLightboxOpen(true)
  }

  // Handle lightbox close
  const closeLightbox = () => {
    setIsLightboxOpen(false)
    setSelectedImage(null)
  }

  // Handle broken images
  const handleImageError = (imageId) => {
    setBrokenImages(prev => new Set([...prev, imageId]))
  }

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isLightboxOpen) return
      if (e.key === 'Escape') closeLightbox()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isLightboxOpen])

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-800 to-gray-900 text-white py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-4xl font-bold mb-4">
            COVID-19 Response
          </h1>
          <p className="text-xl md:text-2xl mb-4 opacity-90">
            Supporting our community during the pandemic
          </p>
        </div>
      </section>

      {/* COVID-19 Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            Our COVID-19 Initiatives
          </h2>
          <p className="text-gray-600 text-center max-w-2xl mx-auto p-2">
            During the COVID-19 pandemic, Shehala Foundation has been at the forefront of providing support to vulnerable communities. We continue to work tirelessly to ensure that those in need receive the care and assistance they deserve.
          </p>
          <p className="text-gray-600 text-center max-w-2xl mx-auto p-2">
            SHEHALA FOUNDATION has distributed essential food support to 350 families. It includes 10 to 25Kg rice, 5Kg flour, 2Kg lintels, 5Kg potato, 5Kg onion, 2-liter cooking oil, 1Kg salt, and 1 to 5 soap bars.
          </p>
          <p className="text-gray-600 text-center max-w-2xl mx-auto p-2">
            We express our sincere thanks and gratitude to those individuals and organizations who have donated generously to carry out this relief work successfully.          
          </p>
        </div>
      </section>

      {/* COVID-19 Photo Gallery */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">
            COVID-19 Response Gallery
          </h2>
          <p className="text-gray-600 text-center max-w-2xl mx-auto mb-10">
            Explore our COVID-19 relief and prevention activities through these images documenting our response to the pandemic.
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-5 py-2 rounded-full transition-all duration-300 font-medium text-sm ${
                  activeCategory === category
                    ? 'bg-blue-600 text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-100 shadow-md'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Photo Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-lg shadow-md cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
                onClick={() => !brokenImages.has(image.id) && handleImageClick(image)}
              >
                {!brokenImages.has(image.id) ? (
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                    onError={() => handleImageError(image.id)}
                  />
                ) : (
                  <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                    <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-white font-medium text-lg">{image.alt}</p>
                    <span className="text-blue-300 text-sm">{image.category}</span>
                  </div>
                </div>
                <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {image.category}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {isLightboxOpen && selectedImage && !brokenImages.has(selectedImage.id) && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={closeLightbox}
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
              onError={() => {
                setBrokenImages(prev => new Set([...prev, selectedImage.id]))
                closeLightbox()
              }}
            />
            <div className="text-center mt-4">
              <h3 className="text-white text-xl font-semibold">{selectedImage.alt}</h3>
              <p className="text-blue-400">{selectedImage.category}</p>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="opacity-80">
            © {new Date().getFullYear()} Shehala Foundation. All rights reserved.
          </p>
          <p className="opacity-60 text-sm mt-2">
            A Compassion-Driven Approach to Corporate Social Responsibility
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Covid19
